import FileLinkView from './components/FileLinkView';
import { assetErrorFile, fileName, fileTooltip } from './filepickerStrings.locstring.json';
import type { FileLinkPayload } from './schema';
import createNewFileAsset from './factory/createNewFileAsset';
import createFileLinkFromClipboardData from './utils/createFileLinkFromClipboardData';
import onAssetInvoked from './utils/onAssetInvoked';
import { lazyInitializeAttachmentFilePicker } from 'owa-attachment-filepicker';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { getUserConfiguration } from 'owa-session-store';
import {
    AssetAriaLabel,
    LEGACY_DEFAULT_MIN_ASSET_WIDTH,
    registerAsset,
} from 'owa-timestream-asset-sdk';

export default registerAsset<FileLinkPayload>({
    type: 'file',
    iconName: ControlIcons.Attach,
    getToolName: () => loc(fileName),
    getTooltip: () => loc(fileTooltip),
    getErrorMessage: () => loc(assetErrorFile),
    isAssetEnabled: () => !getUserConfiguration().SessionSettings?.IsShadowMailbox,
    unsupportedDefaultCommands: [],
    CanvasView: FileLinkView,
    createAssets: createNewFileAsset,
    createEmptyAsset: () => ({
        type: 'file',
        width: LEGACY_DEFAULT_MIN_ASSET_WIDTH,
        payload: {
            filePickerLinkData: {
                fileName: '',
                mimeType: undefined,
                isFolder: false,
            },
            fileProvider: null,
            fileId: '',
            location: '',
            url: '',
            thumbnailUrl: '',
            providerEndpointUrl: '',
        },
    }),
    createAssetFromClipboardData: createFileLinkFromClipboardData,
    onAssetInvoked: onAssetInvoked,
    customRenderDueDate: true,
    getAriaLabel: (payload: FileLinkPayload) =>
        loc(AssetAriaLabel.assetAriaLabel, loc(fileName), getFileName(payload)),
    getTitleString: getFileName,
    getSearchString: (payload: FileLinkPayload) => getFileName(payload) ?? payload.url,
});

function getFileName(payload: FileLinkPayload) {
    return payload.filePickerLinkData?.fileName;
}

// This preload needs to run before any code in this package will work.
lazyInitializeAttachmentFilePicker.import().then(preload => {
    preload();
});
